import { DEFAULT_PRICE_RANGE, SITTER_REVIEWS_ANY_ID } from '~/common/constants/search';

import type { AdvancedFilters } from '~/common/types/search';

export const getIsPriceFilterChanged = (values: AdvancedFilters | undefined): boolean => {
  if (!values) {
    return false;
  }

  const { price } = values;

  return price[0] != DEFAULT_PRICE_RANGE[0] || price[1] != DEFAULT_PRICE_RANGE[1];
};

export const getChangedFilterCount = (values: AdvancedFilters | undefined): number => {
  if (!values) {
    return 0;
  }

  const { sittersHome, sittersPetsKids, aboutSitter, reviewsMin } = values;

  const priceChanged = getIsPriceFilterChanged(values);
  const sittersHomeChanged = sittersHome.length > 0;
  const sittersPetsKidsChanged = sittersPetsKids.length > 0;
  const aboutSitterChanged = aboutSitter.length > 0;
  const reviewsMinChanged = reviewsMin !== SITTER_REVIEWS_ANY_ID;

  return [
    priceChanged,
    sittersHomeChanged,
    sittersPetsKidsChanged,
    aboutSitterChanged,
    reviewsMinChanged,
  ].filter(Boolean).length;
};
